import { React, useState, useEffect } from "react";
import { Alert, Snackbar } from "@mui/material";
import {
  CircularProgress,
  Container,
  makeStyles,
  Paper,
} from "@material-ui/core";
import { redirect, useNavigate, useParams } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import { useCreateNewEmployeeMutation } from "../../api/addEmployeeApi";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import StepLabel from "@mui/material/StepLabel";
import { useSelector, useDispatch } from "react-redux";
import {
  updateAddEmployeeClicked,
  clearEmployeeDetails,
  updateErrorState,
  setCurrentOnbaordingEmployee,
  setIsViewedEmployee,
} from "../../store/reducers/addEmployeeSlice";
//import { updateEmployeeDetails,updateErrorState } from "../../store/reducers/addEmployeeSlice";
import AddEmployeeJson from "./addEmployee.json";
import BasicInfo from "./BasicInfo";
import EmployeePosition from "./EmployeePosition";
import StatutoryInfo from "./StatutoryInfo";
import PaymentMode from "./PaymentMode";
import Experience from "./Experience";
import OtherDocs from "./OtherDocs";
import CustomButton from "../../Components/customComponents/customButton";
import {
  useLazyCreateProfileQuery,
  useLazyFetchEmployeeDetailsQuery,
} from "../../api/profileApi";
import {
  updateEmployeeJson,
  updateFeildsDisabled,
} from "../../store/reducers/addEmployeeSlice";
import { updateErrorMessage } from "../../store/reducers/errorMessageSlice";
import Tooltip from "@mui/material/Tooltip";
import Breadcrumbs from "../../Components/EmployeePunchTracking/BreadCrumbs";
import { genericHeaders, serviceUrl } from "../../utils/apiConfig";
import axios from "axios";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import { useDeleteDraftMutation } from "../../api/draftAPI";

const steps = [
  "PROFESSIONAL DETAILS",
  "PERSONAL DETAILS",
  "ACADEMIC DETAILS",
  "EXPERIENCE",
  "BANK DETAILS",
  "OTHER DOCUMENTS",
];
const steps2 = [
  "PROFESSIONAL DETAILS",
  "PERSONAL DETAILS",
  "ACADEMIC DETAILS",
  "BANK DETAILS",
  "OTHER DOCUMENTS",
];

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    minHeight: "100vh", // Adjust this value based on your layout
  },
  circularProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
  content: {
    // Define styles for your content here
    padding: theme.spacing(2),
  },
}));

const AddEmployee = ({ isInvite }) => {
  const classes = useStyles();
  const empState = useSelector((state) => state.addEmployee.employeeDetails);
  const isViewedEMployee = useSelector(
    (state) => state.addEmployee.isViewedEMployee,
  );
  const errorMessageState = useSelector(
    (state) => state.errorMessage.errorMessage,
  );
  const addEmployeeState = useSelector(
    (state) => state.addEmployee.addEmployeeClicked,
  );
  const errorCheck = useSelector((state) => state.addEmployee.errorState);
  const errorCheckWork = useSelector(
    (state) => state.addEmployee.errorStateWork,
  );
  const feildDisabled = useSelector(
    (state) => state.addEmployee.feildsDisabled,
  );

  const dispatch = useDispatch();
  const [createNewEmployee, { isLoading, isSuccess, isError, error }] =
    useCreateNewEmployeeMutation();
  const [deleteDraft] = useDeleteDraftMutation();
  const [showSnack, setShowSnack] = useState(isSuccess);
  const [snackBarMsg, setShowSnackBarmsg] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [submitInviteEmpLoader, setSubmitInviteEmpLoader] = useState(false);
  const navigate = useNavigate();
  let { empId } = useParams();

  const [createProfile, employeeData] = useLazyCreateProfileQuery();
  const [
    fetchEmployeeDetails,
    {
      isSuccess: isFetchEmployeeDetailsSuccess,
      data: superAdminManageEmployeeData,
    },
  ] = useLazyFetchEmployeeDetailsQuery();
  const role = localStorage.getItem("roles");

  useEffect(() => {
    if (empId && role !== "SUPERADMIN") {
      createProfile({ employeeId: empId });
    } else if (empId && role === "SUPERADMIN") {
      dispatch(setIsViewedEmployee(true));
      fetchEmployeeDetails({ employeeId: empId });
    }
  }, [empId]);
  useEffect(() => {
    if (employeeData.isSuccess && role !== "SUPERADMIN") {
      let empData = employeeData.data;
      dispatch(updateEmployeeJson(empData));
      dispatch(updateFeildsDisabled(true));
    }
    if (isFetchEmployeeDetailsSuccess && role === "SUPERADMIN") {
      let empData = superAdminManageEmployeeData.data;
      dispatch(updateEmployeeJson(empData));
      dispatch(updateFeildsDisabled(true));
    }
  }, [employeeData, superAdminManageEmployeeData]);

  const submitOnBoarding = async () => {
    setSubmitInviteEmpLoader(true);

    try {
      const url = `${serviceUrl}/api/sendinvitation/submit/onboardingform?employeeId=${empState.get_id}`;
      const response = await axios.post(url, empState);
      if (response.status === 200) {
        setSubmitInviteEmpLoader(false);
        dispatch(updateEmployeeJson(AddEmployeeJson));
        toast.success("form Submited Succesfully");
        navigate("/checkMail");
      }
    } catch (error) {
      setSubmitInviteEmpLoader(false);
      toast.error("Form Submission Failed");
    }
  };

  const checkDuplicateUser = async () => {
    try {
      const url = `${serviceUrl}/api/employee/checkduplicateuser`;
      const payLoad = {
        employeeNo: empState.professionalDetails.employeeId,
        professionalEmailId: empState.professionalDetails.companyEmail,
        personalEmailId: empState.personalDetails.email,
      };
      const response = await axios.post(url, payLoad, {
        headers: genericHeaders(),
      });
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      toast.error(error.response.data.message);
      return false;
    }
  };
  const hasExperience =
    Number(empState?.professionalDetails?.totalExperience) > 0;

  const totalSteps = () => {
    if (hasExperience) {
      return steps.length;
    } else {
      return steps2.length;
    }
  };
  const isLastStep = () => {
    return activeStep === totalSteps - 1;
  };
  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    if (!getDisabledState()) {
      dispatch(updateErrorMessage(false));
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? steps.findIndex((step, i) => !(i in completed))
          : activeStep + 1;

      const currentStepError =
        errorCheck && errorCheck[`step${activeStep}`]
          ? errorCheck[`step${activeStep}`]
          : {};
      if (
        activeStep === 0 ||
        activeStep === 1 ||
        activeStep === 2 ||
        activeStep === 3 ||
        activeStep === 4
      ) {
        if (Object.keys(currentStepError).length === 0) {
          setActiveStep(newActiveStep);
        }
      } else {
        setActiveStep(newActiveStep);
      }

      if (newActiveStep == 10) {
        isInvite ? submitOnBoarding(empState) : createNewEmployee(empState);
      }
    } else {
      dispatch(updateErrorMessage(true));
    }
  };
  const handleNextWork = async () => {
    let checkInviteCondition = isInvite ? true : await checkDuplicateUser();
    if (checkInviteCondition) {
      if (!getDisabledState()) {
        dispatch(updateErrorMessage(false));
        const newActiveStepExperience =
          isLastStep() && !allStepsCompleted()
            ? steps2.findIndex((step, i) => !(i in completed))
            : activeStep + 1;
        if (activeStep === 3) {
          const currentStepErrorWork =
            errorCheckWork && errorCheckWork[`step${activeStep}`]
              ? errorCheckWork[`step${activeStep}`]
              : {};

          if (
            activeStep === 0 ||
            activeStep === 1 ||
            activeStep === 2 ||
            activeStep === 3
          ) {
            if (Object.keys(currentStepErrorWork).length === 0) {
              setActiveStep(newActiveStepExperience);
            }
          } else {
            setActiveStep(newActiveStepExperience);
          }

          if (newActiveStepExperience == 10) {
            isInvite ? submitOnBoarding(empState) : createNewEmployee(empState);
          }
        } else {
          const currentStepError =
            errorCheck && errorCheck[`step${activeStep}`]
              ? errorCheck[`step${activeStep}`]
              : {};

          if (
            activeStep === 0 ||
            activeStep === 1 ||
            activeStep === 2 ||
            activeStep === 3
          ) {
            if (Object.keys(currentStepError).length === 0) {
              setActiveStep(newActiveStepExperience);
            }
          } else {
            setActiveStep(newActiveStepExperience);
          }

          if (newActiveStepExperience == 10) {
            isInvite ? submitOnBoarding(empState) : createNewEmployee(empState);
          }
        }
      } else {
        dispatch(updateErrorMessage(true));
      }
    }
  };
  const handleViewNext = () => {
    dispatch(updateErrorMessage(false));
    if (hasExperience) {
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? steps.findIndex((step, i) => !(i in completed))
          : activeStep + 1;

      setActiveStep(newActiveStep);

      if (newActiveStep === 10) {
        isInvite ? submitOnBoarding(empState) : createNewEmployee(empState);
      }
    } else {
      const newActiveStepExperience =
        isLastStep() && !allStepsCompleted()
          ? steps2.findIndex((step, i) => !(i in completed))
          : activeStep + 1;

      setActiveStep(newActiveStepExperience);

      if (newActiveStepExperience === 10) {
        isInvite ? submitOnBoarding(empState) : createNewEmployee(empState);
      }
    }
  };
  const handlePrev = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };
  const handleCancel = () => {
    if (activeStep !== 5) {
      setActiveStep(0);
    }
    setCompleted({});
    dispatch(updateAddEmployeeClicked(false));
    dispatch(clearEmployeeDetails(AddEmployeeJson));
    setTimeout(() => {
      navigate("/manage");
    }, [1000]);
  };
  const isWorkExperienceValid = () => {
    const list = empState?.workExperience;

    if (!Array.isArray(list) || list.length === 0) {
      return false;
    }

    const firstExp = list[0];

    const companyName = firstExp?.companyName?.trim() || "";
    const designation = firstExp?.designation?.trim() || "";
    const startDate = firstExp?.startDate || "";
    const endDate = firstExp?.endDate || "";

    return (
      companyName !== "" &&
      designation !== "" &&
      startDate !== "" &&
      endDate !== ""
    );
  };
  const getDisabledState = () => {
    const isExperienceValid =
  empState.professionalDetails.totalExperience !== "" &&
  empState.professionalDetails.currentCompanyExperience !== "";
    if (
      Number(empState.professionalDetails.totalExperience) > 0
    ) {
      if (
        activeStep != 0 &&
        activeStep != 1 &&
        activeStep != 2 &&
        activeStep != 3 &&
        activeStep != 4
      ) {
        return false;
      }
      if (activeStep == 3) {
        return !isWorkExperienceValid();
      }
      if (
        activeStep == 0 &&
        empState.firstName &&
        empState.lastName &&
        isExperienceValid &&
        (!isInvite
          ? empState.professionalDetails.status &&
            empState.professionalDetails.probationPeriod &&
            empState.professionalDetails.noticePeriod &&
            empState.professionalDetails.shift &&
            empState.professionalDetails.dateofJoining &&
            empState.professionalDetails.employeeId?.length > 2 &&
            empState.professionalDetails.employeeType &&
            empState.professionalDetails.managerId &&
            empState.professionalDetails.workLocation &&
            empState.professionalDetails.department &&
            empState.professionalDetails.currentDesignation &&
            empState.professionalDetails.holidayCalender
          : true)
      ) {
        return false;
      } else if (
        activeStep == 1 &&
        empState.personalDetails.aadharNumber &&
        empState.personalDetails.panNumber &&
        empState.personalDetails.email &&
        empState.personalDetails.gender &&
        empState.personalDetails.primaryContactNo &&
        empState.personalDetails.emergencyContactName &&
        empState.personalDetails.emergencyContactNo &&
        empState.personalDetails.maritalStatus &&
        empState.personalDetails.fatherName &&
        empState.personalDetails.additionalInformation?.aadharDocument &&
        empState.personalDetails.additionalInformation?.panDocument
      ) {
        return false;
      } else if (
        activeStep == 2 &&
        empState.academicDetails.institute &&
        empState.academicDetails.qualification &&
        empState.academicDetails.grade &&
        empState.academicDetails.fromDate &&
        empState.academicDetails.toDate
      ) {
        return false;
      } else if (
        activeStep == 4 &&
        empState.bankDetails.bankName &&
        empState.bankDetails.accountNo &&
        empState.bankDetails.branchName &&
        empState.bankDetails.ifsccode &&
        empState.bankDetails.isUserConfirmed
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        activeStep != 0 &&
        activeStep != 1 &&
        activeStep != 2 &&
        activeStep != 3
      ) {
        return false;
      }
      if (
        activeStep == 0 &&
        empState.firstName &&
        empState.lastName &&
        isExperienceValid &&
        (!isInvite
          ? empState.professionalDetails.status &&
            empState.professionalDetails.probationPeriod &&
            empState.professionalDetails.noticePeriod &&
            empState.professionalDetails.shift &&
            empState.professionalDetails.dateofJoining &&
            empState.professionalDetails.employeeId?.length > 2 &&
            empState.professionalDetails.employeeType &&
            empState.professionalDetails.managerId &&
            empState.professionalDetails.workLocation &&
            empState.professionalDetails.department &&
            empState.professionalDetails.currentDesignation &&
            empState.professionalDetails.holidayCalender
          : true)
      ) {
        return false;
      } else if (
        activeStep == 1 &&
        empState.personalDetails.aadharNumber &&
        empState.personalDetails.panNumber &&
        empState.personalDetails.email &&
        empState.personalDetails.gender &&
        empState.personalDetails.primaryContactNo &&
        empState.personalDetails.emergencyContactName &&
        empState.personalDetails.emergencyContactNo &&
        empState.personalDetails.maritalStatus &&
        empState.personalDetails.fatherName &&
        empState.personalDetails.additionalInformation?.aadharDocument &&
        empState.personalDetails.additionalInformation?.panDocument
      ) {
        return false;
      } else if (
        activeStep == 2 &&
        empState.academicDetails.institute &&
        empState.academicDetails.qualification &&
        empState.academicDetails.grade &&
        empState.academicDetails.fromDate &&
        empState.academicDetails.toDate
      ) {
        return false;
      } else if (
        activeStep == 3 &&
        empState.bankDetails.bankName &&
        empState.bankDetails.accountNo &&
        empState.bankDetails.branchName &&
        empState.bankDetails.ifsccode &&
        empState.bankDetails.isUserConfirmed
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      setShowSnack(true);
      setShowSnackBarmsg("Employee Created Successfully");
      handleCancel();
    }
    if (isError) {
      console.log(error);
      setShowSnack(true);
      setShowSnackBarmsg(
        error && error.data
          ? error.data
          : "Something Went Wrong. Please Try Again",
      );
    }
  }, [isSuccess, isError]);

  const handleClose = () => {
    setShowSnack(false);
  };

  const saveEmployeeDraft = async () => {
    try {
      const reponse = await axios.put(
        `${serviceUrl}/api/onboardingform/hardsave/update`,
        empState,
        { headers: genericHeaders() },
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      !isViewedEMployee &&
      !isInvite &&
      !feildDisabled &&
      !isLoading &&
      !isSuccess
    ) {
      saveEmployeeDraft();
    }
  }, [empState]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const message = "Changes you made may not be saved.";
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (isSuccess) {
      deleteDraft();
    }
  }, [isSuccess]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={showSnack}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert severity={!isError ? "success" : "error"} variant="filled">
          {snackBarMsg}
        </Alert>
      </Snackbar>
      {(isLoading || submitInviteEmpLoader) && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
          //onClick={handleClose}
        >
          <CircularProgress
            color="inherit"
            size={100}
            className={classes.circularProgress}
          />

          <p class="text-white text-4xl ml-[115px] mb-[100px]">
            Please Give us a moment...
          </p>

          {/* <CircularProgress color="inherit" /> */}
        </Backdrop>
      )}

      <div className="mt-32 ml-10 pb-4">
        {feildDisabled ? (
          <></>
        ) : (
          <div className="text-3xl mb-10">{`${
            isInvite ? "Fill the Form" : "Add Employee"
          }`}</div>
        )}
        {role === "SUPERADMIN" && (
          <button
            onClick={() => navigate("/superadmin")}
            className="font-bold mb-8 ml-10 text-lg flex items-center gap-2"
          >
            <KeyboardTabIcon className="rotate-180 mt-2" />
            <span>Back</span>
          </button>
        )}

        <Stepper activeStep={activeStep} alternativeLabel className="mb-10">
          {(hasExperience ? steps : steps2).map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {activeStep === 0 && <BasicInfo isInvite={isInvite} />}
        {activeStep === 1 && <EmployeePosition isInvite={isInvite} />}
        {activeStep === 2 && <StatutoryInfo isInvite={isInvite} />}
        {activeStep === 3 &&
        Number(empState.professionalDetails.totalExperience) > 0 ? (
          <Experience />
        ) : null}
        {activeStep === 3 &&
        !(Number(empState.professionalDetails.totalExperience) > 0) ? (
          <PaymentMode isInvite={isInvite} />
        ) : null}
        {activeStep === 4 &&
        !(Number(empState.professionalDetails.totalExperience) > 0) ? (
          <OtherDocs />
        ) : null}
        {activeStep === 4 &&
        Number(empState.professionalDetails.totalExperience) > 0 ? (
          <PaymentMode />
        ) : null}
        {activeStep === 5 &&
        Number(empState.professionalDetails.totalExperience) > 0 ? (
          <OtherDocs />
        ) : null}
        {/* {activeStep === 5 && <OtherDocs />} */}

        {errorMessageState === true && getDisabledState() && (
          <div className="text-red-500 text-base">
            Note : Please fill all Mandatory Fields
          </div>
        )}

        <div>
          {feildDisabled ? (
            <div className="flex justify-end space-x-2 mr-16">
              <CustomButton
                label="Previous"
                onClick={handlePrev}
                className={`mr-2 ${
                  activeStep === 0
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : ""
                } `}
                disabled={activeStep === 0}
              />
              <CustomButton
                label="Next"
                onClick={handleViewNext}
                className="mr-2 "
                disabled={
                  !(Number(empState?.professionalDetails?.totalExperience) > 0)
                    ? activeStep === 4
                    : activeStep === 5
                }
              />
            </div>
          ) : (
            <>
              <div className="flex justify-end space-x-2 mr-16">
                <CustomButton
                  label="Previous"
                  onClick={handlePrev}
                  className={`mr-2 ${
                    activeStep === 0
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : ""
                  } `}
                  disabled={activeStep === 0}
                />
                {!(Number(empState.professionalDetails.totalExperience) > 0) ? (
                  activeStep !== 4 ? (
                    <div className="group">
                      <CustomButton
                        label="Next"
                        onClick={handleNextWork}
                        className={`mr-2 ${
                          getDisabledState()
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={getDisabledState()}
                      />
                      {getDisabledState() && (
                        <div className="absolute text-red-500 text-sm px-2 py-1 rounded mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                          Please fill all mandatory fields
                        </div>
                      )}
                    </div>
                  ) : (
                    <CustomButton
                      label="Finish"
                      onClick={() => {
                        isInvite
                          ? submitOnBoarding(empState)
                          : createNewEmployee(empState);
                      }}
                      className="bg-blue-primary text-white mr-2"
                    />
                  )
                ) : activeStep !== 5 ? (
                  <div className="group">
                    <CustomButton
                      label="Next"
                      onClick={handleNext}
                      className={`mr-2 ${
                        getDisabledState()
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      disabled={getDisabledState()}
                    />
                    {getDisabledState() && (
                      <div className="absolute text-red-500 text-sm px-2 py-1 rounded mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                        Please fill all mandatory fields
                      </div>
                    )}
                  </div>
                ) : (
                  <CustomButton
                    label="Finish"
                    onClick={() => {
                      isInvite
                        ? submitOnBoarding(empState)
                        : createNewEmployee(empState);
                    }}
                    className="bg-blue-primary text-white mr-2"
                  />
                )}

                <CustomButton
                  label="Cancel"
                  onClick={handleCancel}
                  className=""
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AddEmployee;
